import React from 'react';
import { Heart, ArrowUp, Instagram, ShoppingBag } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-zinc-900 text-white py-16 px-8 relative border-t border-zinc-800 max-md:py-12 max-md:px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-12 cursor-pointer" onClick={scrollToTop}>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12 max-md:gap-8 max-md:text-center">
          <div>
            <h3 className="font-sans text-[1.15rem] mb-6 text-crimson font-bold tracking-tight">
              Über uns
            </h3>
            <p className="font-sans text-zinc-300 leading-[1.7] text-[0.95rem] font-normal tracking-tight">
              Handgefertigte Tauleinen und Leinenwerke mit Leidenschaft und Liebe zum Detail.
            </p>
          </div>
          
          <div>
            <h3 className="font-sans text-[1.15rem] mb-6 text-crimson font-bold tracking-tight">
              Quick Links
            </h3>
            <ul className="list-none p-0">
              <li className="mb-3">
                <button 
                  onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
                  className="font-sans bg-none border-0 text-zinc-300 text-[0.95rem] font-normal tracking-tight cursor-pointer transition-colors duration-200 p-0 text-left max-md:text-center hover:text-crimson"
                >
                  Speisekarte
                </button>
              </li>
              <li className="mb-3">
                <button 
                  onClick={() => document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })}
                  className="font-sans bg-none border-0 text-zinc-300 text-[0.95rem] font-normal tracking-tight cursor-pointer transition-colors duration-200 p-0 text-left max-md:text-center hover:text-crimson"
                >
                  Seilwerke
                </button>
              </li>
              <li className="mb-3">
                <button 
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="font-sans bg-none border-0 text-zinc-300 text-[0.95rem] font-normal tracking-tight cursor-pointer transition-colors duration-200 p-0 text-left max-md:text-center hover:text-crimson"
                >
                  About Me
                </button>
              </li>
              <li className="mb-3">
                <button 
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="font-sans bg-none border-0 text-zinc-300 text-[0.95rem] font-normal tracking-tight cursor-pointer transition-colors duration-200 p-0 text-left max-md:text-center hover:text-crimson"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-sans text-[1.15rem] mb-6 text-crimson font-bold tracking-tight">
              Folge uns
            </h3>
            <div className="flex gap-8 mt-4 max-md:justify-center max-md:gap-4">
              <a 
                href="https://www.instagram.com/leinenluder_lelu/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="flex items-center justify-center text-zinc-400 p-4 rounded-full bg-zinc-800 border border-zinc-700 transition-all duration-200 w-[60px] h-[60px] hover:text-crimson hover:border-crimson max-md:w-[50px] max-md:h-[50px] max-md:p-3"
              >
                <Instagram size={36} strokeWidth={1.5} className="max-md:w-[28px] max-md:h-[28px]" />
              </a>
              <a 
                href="https://www.etsy.com/de/shop/Leinenluder" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="flex items-center justify-center text-zinc-400 p-4 rounded-full bg-zinc-800 border border-zinc-700 transition-all duration-200 w-[60px] h-[60px] hover:text-crimson hover:border-crimson max-md:w-[50px] max-md:h-[50px] max-md:p-3"
              >
                <ShoppingBag size={36} strokeWidth={1.5} className="max-md:w-[28px] max-md:h-[28px]" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="text-center pt-8 border-t border-zinc-800">
          <p className="text-zinc-500 text-sm my-2">
            &copy; {new Date().getFullYear()} Leinenluder. Alle Rechte vorbehalten.
          </p>
          <p className="text-zinc-500 flex items-center justify-center gap-1 text-sm my-2">
            Mit <Heart size={16} fill="#dc2626" color="#dc2626" className="inline-block" /> handgefertigt in Deutschland
          </p>
        </div>

        <button 
          className="fixed bottom-[30px] right-[30px] w-[50px] h-[50px] bg-crimson text-white border-0 rounded-xl cursor-pointer transition-all duration-200 z-[999] flex items-center justify-center p-0 hover:bg-red-500 hover:-translate-y-0.5 max-md:w-[45px] max-md:h-[45px] max-md:bottom-5 max-md:right-5"
          onClick={scrollToTop}
        >
          <ArrowUp size={24} />
        </button>
      </div>
    </footer>
  );
};

export default Footer;

